import React from 'react';
import { useRaceStore } from '../../stores/raceStore';
import { useTranslation } from '../../utils/i18n';
import { WheatIcon, FlameIcon, DropletIcon, InfoIcon, ZapIcon } from 'lucide-react';
export function NutritionProfileSection() {
  const {
    t
  } = useTranslation();
  const {
    settings,
    updateNutritionBaselines
  } = useRaceStore();
  const params = settings.athleteProfile.params;
  const baselineSodiumMgPerHour = Math.round(500 * params.sodiumMultiplier);
  const NUTRITION_FACTORS = [{
    key: 'baselineChoPerHourG' as const,
    label: t('nutrition.carbs'),
    unit: 'g/h',
    icon: WheatIcon,
    color: '#FF9500',
    bg: 'bg-[#FF9500]/10',
    border: 'border-[#FF9500]/20',
    description: t('nutrition.carbsDesc')
  }, {
    key: 'baselineCalPerHourKcal' as const,
    label: t('nutrition.calories'),
    unit: 'kcal/h',
    icon: FlameIcon,
    color: '#E34402',
    bg: 'bg-[#E34402]/10',
    border: 'border-[#E34402]/20',
    description: t('nutrition.caloriesDesc')
  }, {
    key: 'baselineFluidMlPerHour' as const,
    label: t('nutrition.fluids'),
    unit: 'ml/h',
    icon: DropletIcon,
    color: '#0EA5E9',
    bg: 'bg-[#0EA5E9]/10',
    border: 'border-[#0EA5E9]/20',
    description: t('nutrition.fluidsDesc')
  }, {
    key: 'baselineSodiumMgPerHour' as const,
    label: t('nutrition.sodium'),
    unit: 'mg/h',
    icon: ZapIcon,
    color: '#7B61FF',
    bg: 'bg-[#7B61FF]/10',
    border: 'border-[#7B61FF]/20',
    description: t('nutrition.sodiumDesc')
  }];
  const values: Record<string, number> = {
    baselineChoPerHourG: params.baselineChoPerHourG,
    baselineCalPerHourKcal: params.baselineCalPerHourKcal,
    baselineFluidMlPerHour: params.baselineFluidMlPerHour,
    baselineSodiumMgPerHour: baselineSodiumMgPerHour
  };
  const handleChange = (key: string, value: number) => {
    if (key === 'baselineSodiumMgPerHour') {
      const newMultiplier = value / 500;
      updateNutritionBaselines({
        sodiumMultiplier: newMultiplier
      } as any);
    } else {
      updateNutritionBaselines({
        [key]: value
      });
    }
  };
  return <div className="bg-white rounded-2xl border border-[#E8E8ED] shadow-sm overflow-hidden" data-id="element-1062">
      <div className="px-5 py-3.5 border-b border-[#E8E8ED]" data-id="element-1063">
        <div className="flex items-center gap-2.5" data-id="element-1064">
          <WheatIcon className="h-5 w-5 text-[#FC4C02]" data-id="element-1065" />
          <span className="text-base font-bold text-[#2D2D2D]" data-id="element-1066">
            {t('nutrition.targets')}
          </span>
        </div>
      </div>

      <div className="p-5 space-y-4" data-id="element-1067">
        <p className="text-sm text-[#6B6B76]" data-id="element-1068">
          {t('nutrition.targetsSubtitle')}
        </p>

        {/* Info callout */}
        <div className="flex gap-2.5 p-3 rounded-xl bg-[#F0F9FF] border border-[#BAE6FD]" data-id="element-1069">
          <InfoIcon className="w-4 h-4 text-[#0284C7] flex-shrink-0 mt-0.5" data-id="element-1070" />
          <p className="text-xs text-[#0C4A6E] leading-relaxed" data-id="element-1071">
            {t('nutrition.targetsInfo')}
          </p>
        </div>

        {/* Editable factors */}
        <div className="space-y-3" data-id="element-1072">
          {NUTRITION_FACTORS.map(factor => {
          const Icon = factor.icon;
          return <div key={factor.key} className="bg-[#F7F7FA] rounded-xl border border-[#E8E8ED] p-3.5" data-id="element-1073">
                <div className="flex items-start gap-3" data-id="element-1074">
                  <div className={`w-9 h-9 rounded-lg ${factor.bg} flex items-center justify-center flex-shrink-0 mt-0.5`} data-id="element-1075">
                    <Icon className="w-4 h-4" style={{
                  color: factor.color
                }} data-id="element-1076" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-1077">
                    <div className="flex items-center justify-between gap-3 mb-1" data-id="element-1078">
                      <span className="text-sm font-bold text-[#2D2D2D]" data-id="element-1079">
                        {factor.label}
                      </span>
                      <div className="flex items-center gap-1.5" data-id="element-1080">
                        <input type="number" min={0} value={Math.round(values[factor.key])} onChange={e => handleChange(factor.key, parseFloat(e.target.value) || 0)} className="w-16 h-8 px-2 bg-white border border-[#E8E8ED] rounded-lg text-sm font-bold text-[#2D2D2D] text-center tabular-nums focus:ring-2 focus:ring-[#FC4C02] focus:border-transparent transition-all" data-id="element-1081" />
                        <span className="text-xs font-semibold text-[#9B9BA7] whitespace-nowrap" data-id="element-1082">
                          {factor.unit}
                        </span>
                      </div>
                    </div>
                    <p className="text-[11px] leading-relaxed text-[#6B6B76]" data-id="element-1083">
                      {factor.description}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </div>;
}